/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

/**
 * Bookmarks service
 * @namespace BookmarksService
 * @description Service for display of bookmarks
 */
!function () {
    "use strict";

    angular.module('webReader').service('BookmarksService', constructor);
    /**
     * @name Styles
     * @function
     * @description Creates or returns reference to singleton object that allows to work with this service
     * @returns {Object} - singleton service object
     * @memberof BookmarksService
     */
    function constructor(DocumentService, DocumentModel) {
        var self = this;
        var bookmarksCollection = [];
        var onBookmarksChange = [];
        var onBookmarksWrapperOffsetChange = [];
        var onRenderedBookmarksUpdate = [];

        self.executeSubscriptions = function(callbacks, args) {
            var self = this;
            return _.every(callbacks, function (fn) {
                if (!_.isNull(fn)) {
                    return fn.apply(self, [args]) !== false;
                }
            })
        };

        self.subscribe = {
            onBookmarksChange: function (callback) {
                onBookmarksChange.push(callback);
            },
            onBookmarksWrapperOffsetChange: function (callback) {
                onBookmarksWrapperOffsetChange.push(callback);
            },
            onRenderedBookmarksUpdate: function (callback) {
                onRenderedBookmarksUpdate.push(callback);
            },
        };

        self.create = function(DOMElement){
            //container = DOMElement;
        };

        self.createBookmark = function(noteObject, chapterId) {
            var newBookmarkObject = noteObject;
            newBookmarkObject.chapterId = chapterId;
            bookmarksCollection.push(newBookmarkObject);
            self.executeSubscriptions.call(this, onRenderedBookmarksUpdate, {});
            self.executeSubscriptions.call(this, onBookmarksChange, {});
        };

        self.getBookmarks = function(){
            return bookmarksCollection;
        };

        self.updateScrollPosition = function(newPosition){
            self.executeSubscriptions.call(this, onBookmarksWrapperOffsetChange, { newY: newPosition });
        };

        self.getBookmark = function(noteIndex){
            return bookmarksCollection[noteIndex];
        };

        self.removeBookmark = function(uuid) {
            for(var i = bookmarksCollection.length - 1; i>=0 && bookmarksCollection[i].uuid !== uuid; i--) {};
            if (i >= 0) {
                bookmarksCollection.splice(i, 1);
                self.executeSubscriptions.call(this, onRenderedBookmarksUpdate, {});
            }
        }
    }
    constructor.$inject = ["DocumentService", "DocumentModel"];
}();